module.exports = __webpack_public_path__ + "img/083-somalia.a05cf800.svg";